import React from 'react';

import { MochiInput } from '@autopass-web/mochi-component';

import { type EmailFieldConfig } from '../utils';

import type { ComponentProps, ReactNode } from 'react';

export const Hint = ({ children }: { children: string }) => {
  return <div className="text-xs text-gray-600">{children}</div>;
};

type EmailInputProps = ComponentProps<typeof MochiInput> & {
  config: EmailFieldConfig;
  hint?: string | ReactNode;
};

export const EmailInput = React.forwardRef<HTMLInputElement, EmailInputProps>(
  ({ config, hint = null, ...props }, ref) => {
    if (config === 'never') {
      return null;
    }

    return (
      <>
        <MochiInput
          ref={ref}
          autoComplete="off"
          variant="grey"
          inputMode="email"
          placeholder={
            config === 'required'
              ? '輸入寄送 Email 信箱'
              : '輸入寄送 Email 信箱（選填）'
          }
          {...props}
        />
        {hint && typeof hint === 'string' ? <Hint>{hint}</Hint> : hint}
      </>
    );
  },
);
